import * as React from "react";

import { isNonEmptyString } from "@cayuse/shared-react.utils.type-checks";

import styles from "./styles.css";

export const NotificationMessage = ({ message, meta }) => (
	<div className={styles.body} data-testid="notification-message">
		<p>{message}</p>
		{isNonEmptyString(meta) && <p className={styles.meta}>{meta}</p>}
	</div>
);
